import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'tag-selector',
	template: require('./tag-selector.component.html'),
	encapsulation: ViewEncapsulation.None,
	styles: []
})
export class TagsSelectorComponent implements OnInit {

	@Input("availableTags")
	availableTags = [];

	selectedTags = [];
	dropdownSettings = {};

	ngOnInit(): void {

		this.dropdownSettings = {
			labelKey: "name",
			primaryKey: "id",
			singleSelection: false,
			text: "Select Tags",
			enableSearchFilter: true,
			classes: "",
			badgeShowLimit: 15

		};
	}

	@Input("selectedTags")
	set selected_Tags(value) {
		this.selectedTags = value;
	}

	@Output("selectedTagsChange")
	selectedTagsChange: EventEmitter<any[]> = new EventEmitter<any[]>();

	onItemSelect(item: any) {
		this.selectedTagsChange.emit(this.selectedTags);

	}

	onItemDeSelect(item: any) {
		this.selectedTagsChange.emit(this.selectedTags);

	}

	onSelectAll(items: any) {
		this.selectedTagsChange.emit(this.selectedTags);

	}

	onDeSelectAll(items: any) {
		this.selectedTagsChange.emit(this.selectedTags);
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/tag-selector.component.ts